module.exports = __webpack_public_path__ + "static/media/menu_icon_moff_check_hover.103dc197.png";